export type AppErrorCode =
  | "AUTH_FAILED"
  | "EMAIL_IN_USE"
  | "NETWORK_ERROR"
  | "VALIDATION_PASSWORD_TOO_WEAK"
  | "SERVER_UNAVAILABLE"
  | "UNKNOWN_ERROR";

type AppErrorProps = {
  code: AppErrorCode;
  internalMessage: string;
  uiMessage: string;
  isExpected: boolean;
  translations?: Record<string, string>;
};

export class AppError extends Error {
  code: AppErrorCode;
  internalMessage: string;
  uiMessage: string;
  translations?: Record<string, string>;
  isExpected: boolean;

  constructor({
    code,
    internalMessage,
    uiMessage,
    isExpected = true,
    translations,
  }: AppErrorProps) {
    super(internalMessage);
    this.code = code;
    this.internalMessage = internalMessage;
    this.uiMessage = uiMessage;
    this.translations = translations;
    this.isExpected = isExpected;
  }

  getUiMessage(locale: string) {
    return this.translations?.[locale] || this.uiMessage;
  }
}
